export default __webpack_public_path__ + "static/media/apply-discount-img.87171786.png";